<template>
	<div>
		<PagesHeading  />
		<div id="albums" class="container" :class="{ 'loading-app-style': loading }">
			<div v-if="loading"  style="display: flex; align-items: center; justify-content: center">
				<div class="loader"></div>
			</div>
	
			<div v-else class="row mt-5 py-5">
				<div v-for="(album, index) in albums" :key="index" class="col-lg-4 col-md-6 col-12 mb-4 d-flex justify-content-center">
					<router-link :to="{name: 'albums-view', params: {id: album.id} }">
						<div class="card" style="width: 18rem;">
							<img :src="album.primaryImage.url" class="card-img-top same-height animated">
							<div class="card-body">
									<p class="card-text text-center text-muted py-0">{{ album.title }}</p>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import PagesHeading from '@/components/PagesHeading.vue';
export default {
	components: {
		PagesHeading
	},
	data() {
		return {
			loading: true
		}
	},
	computed: {
		...mapState({
			albums: state => state.albums.albums
		})
	},
	methods: {
		...mapActions('albums', ['fetchAlbums']),
		fetch() {
			if (!this.albums[0]) {
				this.fetchAlbums()
					.finally(() => { this.loading = false });
			} else {
				this.loading = false 
			}
		}
	},
	created() {
		this.fetch();
	}
}

</script>
<style scoped>
body {
	background-color: #fff;
}

.card {
	border: none;
	box-shadow: none !important;
}

.animated:hover {
	animation-duration: 3s;
	animation: swing ease-in-out 3s alternate;
	transform-origin: center -20px;
	float: left;
	box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
}

.same-height {
	height: 25vh;
	object-fit: cover;
	background-size: cover;
}

.card img {
	border: 16px solid #fcad4d;
	box-shadow: -1px 2px 8px rgba(0, 0, 0, 0.25);
}

.color {
	color: rgb(252, 173, 77);
}

a {
	text-decoration: none !important;
}

a:hover {
	text-decoration: none !important;
}

@media (max-width: 520px) and (min-width: 380px) {
	.card {
		margin: 10px 10% !important;
	}
}

@media (max-width: 380px) {
	.card {
		margin: 10px 10% !important;
	}
}

html[dir="rtl"] .animated:hover {
	float: right;
}

.loader {
	border: 8px solid #f3f3f3;
	/* Light grey */
	border-top: 8px solid #fcad4d;
	/* Blue */
	border-radius: 50%;
	width: 60px;
	height: 60px;
	animation: spin 2s linear infinite;
	margin: 0 auto;
	/* position: absolute;
	top: 70%;
	bottom: 50% */
}

.loading-app-style {
	height: 150px;
	display: flex;
	align-items: center;
	justify-content: center
}

@keyframes swing {
	0% {
		transform: rotate(-8deg);
	}
	15% {
		transform: rotate(8deg);
	}
	25% {
		transform: rotate(-6deg);
	}
	40% {
		transform: rotate(6deg);
	}
	55% {		
		transform: rotate(-3deg);
	}
	70% {
		transform: rotate(3deg);
	}
	85% {

		transform: rotate(-1deg);
	}
	95% {

		transform: rotate(1deg);
	}
	100%{
		transform: rotate(0deg);
	}
}</style>